import React, { useEffect, useState } from 'react';
import {
  Card,
  CardContent,
  Typography,
  Snackbar,
  SlideProps,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../store/store';
import { removeMessage } from '../redux/infoMessageSlice';
import { Slide } from '@mui/material';
import { useTranslation } from 'react-i18next';

const InfoCard: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const message = useSelector((state: RootState) => state.infoMessage.message);
  const error = useSelector((state: RootState) => state.infoMessage.error);
  const type = useSelector((state: RootState) => state.infoMessage.type);
  const duration = 3000;

  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!message) {
      setOpen(false);
      return;
    }

    setOpen(true);
    const timer = setTimeout(() => {
      setOpen(false);
      dispatch(removeMessage());
    }, duration);

    return () => clearTimeout(timer);
  }, [message]);

  const transition = (props: SlideProps) => (
    <Slide {...props} direction="right" />
  );

  const translatedMessage = message ? t(message, { error: error }) : '';
  const title = type === 'success' ? t('success.title') : t('error.title');
  const titleColor = type === 'success' ? 'success.main' : 'error';

  return (
    <Snackbar
      open={Boolean(message) && open}
      autoHideDuration={duration}
      onClose={() => {
        setOpen(false);
        dispatch(removeMessage());
      }}
      TransitionComponent={transition}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      sx={{
        backgroundColor: 'none',
      }}
    >
      <Card sx={{ maxWidth: 400 }}>
        <CardContent>
          <Typography variant="h6" color={titleColor} gutterBottom>
            {title}
          </Typography>
          <Typography variant="body2">{translatedMessage}</Typography>
        </CardContent>
      </Card>
    </Snackbar>
  );
};

export default InfoCard;
